import { render, staticRenderFns } from "./PricingPage.vue?vue&type=template&id=0c4e0f5a&scoped=true"
import script from "./PricingPage.vue?vue&type=script&lang=js"
export * from "./PricingPage.vue?vue&type=script&lang=js"
import style0 from "./PricingPage.vue?vue&type=style&index=0&id=0c4e0f5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e0f5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4e0f5a')) {
      api.createRecord('0c4e0f5a', component.options)
    } else {
      api.reload('0c4e0f5a', component.options)
    }
    module.hot.accept("./PricingPage.vue?vue&type=template&id=0c4e0f5a&scoped=true", function () {
      api.rerender('0c4e0f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Informational/PricingPage.vue"
export default component.exports